import { render } from "./message.vue?vue&type=template&id=0819b41e&scoped=true&ts=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"

import "./message.vue?vue&type=style&index=0&id=0819b41e&scoped=true&lang=css"
import "./message.vue?vue&type=style&index=1&id=0819b41e&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0819b41e"]])

export default __exports__